import React, { useContext, useEffect, useState } from "react";
import AttendancePage from "../../../../entities/DashboardPage/HRModule/Attendance";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import moment from "moment-timezone";
import { useAlert } from "../../../../context/AlertContext";
import dayjs from "dayjs";
import { ProfileContext } from "../../../../context/ProfileContext";
import { attendanceService, employeeService } from "../../../../api";
import { getBlobErrorMessage } from "../../../../utils/blobError";

const Attendance = () => {
  const [permission, setPermission] = useState(null);
  const [profileState, updateProfileState] = useContext(ProfileContext);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [EmployeeData, setEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [holidayOpen, setHolidayOpen] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");

  const { showAlert } = useAlert();
  const [toDate, setToDate] = useState(dayjs());
  const [fromDate, setFromDate] = useState(dayjs());
  const [employeeCheckeIn, setEmployeeCheckedIn] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [note, setNote] = useState("");
  const [searchText, setSearchText] = useState("");
  const id = localStorage.getItem("employeeId");
  const [from, setFrom] = useState("");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);
  useEffect(() => {
    getAttendanceList(searchText, "", fromDate, toDate, "", "", page);
  }, [fromDate, toDate, page, searchText]);
  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      if (!permission?.attendance?.isEdit) {
        getCheckIn();
      }
      if (id) {
        getEmployeeDetails(id);
      }
    }
  }, [permission]);
  const getAttendanceList = async (text, filter, fromDateParam, toDateParam, status, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getAttendanceList(
        text,
        filter,
        fromDateParam || fromDate,
        toDateParam || toDate,
        status,
        sort,
        page
      );
      if (result?.success) {
        let attendance = result?.data?.attendance || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.attendance?.isView === true;
          const hasEditPermission = permission?.attendance?.isEdit === true;
          const hasEditOwnPermission = permission?.attendance?.isEditOwn === true;
          const hasEditDepartmentPermission = permission?.attendance?.isEditDepartment === true;
          
          if (hasEditPermission || hasEditDepartmentPermission) {
            setTotal(result?.data?.totalCount);
          } else if (hasViewPermission || hasEditOwnPermission) {
            attendance = attendance.filter((att) => att?.employee?._id === employeeId || att?.employee?.userId === employeeId);
            setTotal(attendance.length);
          } else {
            // No view permission, show nothing
            attendance = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.totalCount);
        }
        
        setData(attendance);
        setFilteredData(attendance);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getCheckIn = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getCheckIn();
      if (result?.success) {
        setEmployeeCheckedIn(result?.data?.isCheckin);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const markAbsent = async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleAbsent(id);
      if (result?.success) {
        getAttendanceList(searchText || "", "", fromDate, toDate, "", "", page);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const getcheckedInEmployee = async (text) => {
    setLoading(true);

    try {
      // const result = await AuthService.getAttendanceList(text, "", fromDate);
      const result = await employeeService.search(text, 1, null, "attendance")
      console.log(result, "result of attendanceList----")
      if (result?.success) {
        // setCheckedInEmployeeData(result?.data?.attendance);
        setEmployeeData(result?.data?.employees);
        // setPageCount(result?.data?.totalCount)
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getEmployeeDetails = async (id) => {
    setLoading(true);

    try {
      const result = await AuthService.getEmployeeDetails(id);
      if (result?.success) {
        updateProfileState([result?.data]);
        // setPageCount(result?.data?.totalCount)
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.deleteAttendance(id);
      if (result?.success) {
        getAttendanceList(searchText || "", "", fromDate, toDate, "", "", page);
        // showAlert(result?.data,"success")
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.data, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleExport = async (email, fromDate, toDate, type) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleExport(email, fromDate, toDate, type);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const mimeType = type === "pdf" ? "application/pdf" : type === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${type === "pdf" ? "pdf" : type === "excel" ? "xlsx" : "csv"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        setOpens(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleImport = async (data) => {
    try {
      const result = await AuthService.handleAttendanceImport(data);
      if (result?.success) {
        showAlert(result?.message || "Import completed successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Import failed", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }
  // ----------------------------------------------------------------
  // Check in api calling
  // ----------------------------------------------------------------

  const handleCheckIn = async (time, date, endDate, id, includeNonScheduledDays) => {
    setLoader(true);
    const timeZone = moment.tz.guess();
    try {
      const result = await attendanceService.checkin(date, time, endDate, id, timeZone, includeNonScheduledDays);
      if (result?.success) {
        getAttendanceList(searchText || "", "", fromDate, toDate, "", "", page);
        setLoader(false);
        setOpen(false);
        getCheckIn();
        setNote("");
        showAlert(result?.message, "success");
      }
      else {
        showAlert(result?.message, "error");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  // ----------------------------------------------------------------
  // Checkout api calling
  // ----------------------------------------------------------------

  const handleCheckOut = async (time, date, endDate, id, includeNonScheduledDays) => {
    setLoader(true);
    const timeZone = moment.tz.guess();
    try {
      const result = await attendanceService.checkout(date, time, endDate, id, timeZone, includeNonScheduledDays);
      if (result?.success) {
        getAttendanceList(searchText || "", "", fromDate, toDate, "", "", page);
        showAlert(result?.message, "success");
        setOpen(false);
        setNote("");
        setLoader(false);
      } else {
        showAlert(result?.message, "error");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  // ----------------------------------------------------------------
  // Check is holiday exist in date range
  // ----------------------------------------------------------------

  const handleCheckHoliday = async (start, end, email, from) => {
    setLoader(true);

    try {
      const result = await attendanceService.checkHoliday(start, end, email, from);

      if (result.success && result.data.isHoliday) {
        setPopupMsg("There is a holiday in the provided range, and it’ll be marked as overtime.");
        setHolidayOpen(true);
        showAlert(result?.message, "success");
      } else if (result.success && result.data.isCheckIn) {
        setPopupMsg("You are already checked in within this date range. Are you sure you want to modify the details?");
        setHolidayOpen(true);
        showAlert(result?.message, "error");  // Changed to "error"
      } else if (result.success && result.data.isCheckOut) {
        setPopupMsg("You are already checked out within this date range. Are you sure you want to modify the details?");
        setHolidayOpen(true);
        showAlert(result?.message, "error");  // Changed to "error"
      } else {
        showAlert(result?.message, "error");
        setLoader(false);
        setHolidayOpen(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };


  const handleSearch = (text) => {
    setSearchText(text); // Update search text
    getAttendanceList(text, "", fromDate, toDate, "", "", page); // Fetch new results with correct parameters
  };
  const handleFilter = (txt, filter) => {
    getAttendanceList(searchText || "", filter, fromDate, toDate, "", "", page);
  };

  // ----------------------------------------------------------------
  // Search all employees list
  // ----------------------------------------------------------------

  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await employeeService.search(text, 1, null, "attendance");
      console.log(result, "result of search list ----")
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSort = (sort) => {
    if (sort) {
      getAttendanceList(searchText || "", "", fromDate, toDate, "", sort, page);
    }
  };

  return (
    <AttendancePage
      data={filteredData.length > 0 ? filteredData : data}
      note={note}
      handleExport={handleExport}
      setNote={setNote}
      page={page}
      total={total}
      setPage={setPage}
      handleSort={handleSort}
      loading={loading}
      employeeCheckeIn={employeeCheckeIn}
      employeeCheckeInData={EmployeeData}
      EmployeeData={from === "checkIn" ? EmployeeData : EmployeeData}
      setData={setData}
      handleDelete={handleDelete}
      toDate={toDate}
      setToDate={setToDate}
      handleApi={getAttendanceList}
      fromDate={fromDate}
      setFromDate={setFromDate}
      permission={permission}
      role={role}
      getcheckedInEmployee={getcheckedInEmployee}
      open={open}
      setOpen={setOpen}
      opens={opens}
      setOpens={setOpens}
      loader={loader}
      handleCheckIn={handleCheckIn}
      handleCheckout={handleCheckOut}
      handleSearch={handleSearch}
      handleFilter={handleFilter}
      SearchEmployee={SearchEmployee}
      profileState={profileState}
      updateProfileState={updateProfileState}
      handleImport={handleImport}
      markAbsent={markAbsent}
      handleCheckHoliday={handleCheckHoliday}
      holidayOpen={holidayOpen}
      setHolidayOpen={setHolidayOpen}
      popupMsg={popupMsg}
      setEmployeeData={setEmployeeData}
      from={from}
      setFrom={setFrom}
    />
  );
};

export default Attendance;
